import { TranslatableText } from '@dreryk/react-common';
import { Button, ButtonVariant } from '@dreryk/react-components';

import { StyledGuardianDetailsModalOpenButton } from './StyledGuardianDetailsModalOpenButton';

type GuardianDetailsModalOpenButtonProps = {
   readonly onClick: VoidFunction;
   readonly label: TranslatableText;
};

export const GuardianDetailsModalOpenButton = (props: GuardianDetailsModalOpenButtonProps): JSX.Element => (
   <StyledGuardianDetailsModalOpenButton>
      <Button
         testId='openGuardianDetails'
         variant={ButtonVariant.SECONDARY}
         label={props.label}
         type='button'
         onClick={props.onClick}
      />
   </StyledGuardianDetailsModalOpenButton>
);
